import React, { PureComponent } from 'react'

import {
  List,
  InfiniteLoader,
  CellMeasurer,
  CellMeasurerCache
} from 'react-virtualized'
import InteractionListItemContainer from '../../containers/Dashboard/InteractionListItemContainer'
import InteractionItemMiddle from '../../containers/Dashboard/InteractionItemMiddle'

class VirtualizedInteractionsList extends PureComponent {
  constructor(props) {
    super(props)

    this._cache = new CellMeasurerCache({
      minHeight: 83,
      defaultHeight: 96,
      fixedWidth: true
    })

    this.listRef = React.createRef()
  }

  rowRenderer = ({ key, index, style, parent }) => {
    const { entities, width, fetchInteraction } = this.props
    const entity = entities[index]

    if (width > 960 || width < 560) {
      return (
        <CellMeasurer
          cache={this._cache}
          columnIndex={0}
          key={key}
          rowIndex={index}
          parent={parent}
        >
          <InteractionListItemContainer
            entity={entity}
            width={width}
            className="virtualRow"
            style={style}
          />
        </CellMeasurer>
      )
    } else {
      return (
        <CellMeasurer
          cache={this._cache}
          columnIndex={0}
          key={key}
          rowIndex={index}
          parent={parent}
        >
          <InteractionItemMiddle
            interaction={entity}
            style={style}
            onClickHandler={() => fetchInteraction(entity.interaction_id)}
          />
        </CellMeasurer>
      )
    }
  }

  lastEntityId = ''
  scrollToTop = 0

  componentDidUpdate() {
    const { entities, loading, scrollToTop } = this.props

    if (scrollToTop) {
      this.listRef.current.scrollToRow(0)
    }

    if (!loading) {
      if (entities.length && entities[0].interaction_id) {
        if (this.lastEntityId !== entities[0].interaction_id) {
          this.lastEntityId = entities[0].interaction_id
        }
      }

      setTimeout(() => {
        try {
          this._cache.clearAll()
          this.listRef.current.forceUpdate()
          this.listRef.current.forceUpdateGrid()
        } catch (e) {}
      }, 1)
    }
  }

  render() {
    const { entities, width, height, isMoreToLoad } = this.props

    return (
      <InfiniteLoader
        isRowLoaded={this.isRowLoaded}
        rowCount={isMoreToLoad ? entities.length + 1 : entities.length}
        loadMoreRows={this.loadMoreRows}
        threshold={5}
      >
        {({ onRowsRendered }) => (
          <List
            ref={this.listRef}
            onRowsRendered={onRowsRendered}
            width={width}
            height={height}
            rowCount={entities.length}
            rowRenderer={this.rowRenderer}
            rowHeight={this._cache.rowHeight}
            deferredMeasurementCache={this._cache}
          />
        )}
      </InfiniteLoader>
    )
  }

  isRowLoaded = ({ index }) => index < this.props.entities.length

  loadMoreRows = () => {
    if (!this.props.loading) {
      this.props.fetchInteractions(true)
    }
  }
}

export default VirtualizedInteractionsList
